import "./BookConsultation.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import BookingForm from "./sections/BookingForm";
import ConfirmationCta from "./sections/ConfirmationCta";
import Footer from "@/reusable_sections/Footer";
export default function BookConsultationPage() {
  return <div>
      <Header />
      <Hero />
      <BookingForm />
      <ConfirmationCta />
      <Footer />
    </div>;
}